angular.module("siter.io").controller "EditImageCtrl", ["$scope","$rootScope", "$modalInstance", "Widget", "Translit", "FileUploader", "Restangular", "$state", "$cookies",  "image", "$timeout", ($scope, $rootScope, $modalInstance, Widget, Translit, FileUploader, Restangular, $state, $cookies, image, $timeout) ->

  $scope.loadImagesTags = (query) ->
    Restangular.all('/images/tags').getList()

  $scope.edit_image = image
  $scope.edit_image.tag = [{text: $scope.edit_image.tag}]


  # Close

  $scope.landing = {}
  $scope.cancel = ->
    $modalInstance.dismiss "cancel"


  # Preview web uploader

  $scope.imageUploader = new FileUploader(
    url: "#{Restangular.configuration.baseUrl}/images/#{image.id}"
    autoUpload: false
    method: "PUT"
    alias: "image_attributes[source]"
    headers : {
      'X-AUTH-TOKEN': Restangular.defaultHeaders['X-AUTH-TOKEN']
    }
  )

  $scope.imageUploader.onAfterAddingFile = (item) ->
    types = ["image/jpeg", "image/png"]
    if item.file.type not in types
      alert("The file must be png or jpg")
      return false
  $scope.imageUploader.onSuccessItem = (fileItem, response, status, headers) ->
    $scope.imageUploader.clearQueue()
    image.image_attributes = response.image_attributes
    return

  $scope.imageUploader.onErrorItem = (fileItem, response, status, headers) ->
    return


  $scope.updating = false

  $scope.updateImage = (image, newTemplateForm) ->
    return false if newTemplateForm.$invalid
    $scope.updating = true
    $timeout ->

      if Array.isArray(image.tag) and image.tag.length > 0
        image.tag = image.tag[0].text

      Widget.updateImage(image).then (edit_image) ->
        $scope.edit_image = edit_image
        $scope.updating = false
        $scope.imageUploader.uploadAll()
        $scope.close()
      , (errors) ->
        $scope.errors = errors.data.errors
        $scope.updating = false


  # Close

  $scope.close = ->
    $modalInstance.dismiss "close"
]



// WEBPACK FOOTER //
// ./src/app/dashboard/images/edit_image.controller.coffee